import gql from 'graphql-tag'

const ADD_MEMBER = gql`
mutation($fname:String, $lname:String, $rmnid: String,
$rank:String, $branch:String, $email:String, $discord_id:String) {
  addUpdateMember(fname:$fname, lname:$lname, rmnid:$rmnid,
  rank:$rank, branch:$branch, email:$email, discord_id:$discord_id){
    _id
    rmn_id
    rank
    first_name
    last_name
    branch
    email
    discord_id
    awards {
      award
      awarded
    }
    history {
      position {
        display_name
      }
      started
      left
    }
  }
}
`

export default ADD_MEMBER
